import { BodyDecoder } from '@iotize/tap/client/api';
import { BodyEncoder } from '@iotize/tap/client/api';
import { NumberConverter } from './number-converter';

export class BooleanConverter
  implements BodyEncoder<boolean>, BodyDecoder<boolean>
{
  static IS_LEAST_SIGNIFICANT_BIT_FIRST = true;

  static _instance?: BooleanConverter = undefined;

  constructor(protected _mask: number = 0x1) {}

  public decode(data: Uint8Array): boolean {
    var value = NumberConverter.fromBytes(
      data,
      data.length,
      false,
      BooleanConverter.IS_LEAST_SIGNIFICANT_BIT_FIRST,
    );
    return BooleanConverter.decodeFromNumber(this._mask, value);
  }

  public encode(value: boolean): Uint8Array {
    return Uint8Array.from([value ? this._mask : 0]);
  }

  public static decodeFromNumber(mask: number, value: number) {
    return (mask == 0 && value == 0) || (value & mask) != 0;
  }

  public static instanceBit0() {
    if (!BooleanConverter._instance) {
      BooleanConverter._instance = new BooleanConverter(0b1);
    }
    return BooleanConverter._instance;
  }
}
